module.exports = __webpack_public_path__ + "static/media/issue3.0ce53726.webp";